<svg
  width="33"
  height="33"
  viewBox="0 0 33 33"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_2053_1454)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.1034 0.153772L27.3191 0.508781C25.8525 0.646363 25.1192 0.715155 24.947 1.19296C24.7748 1.67077 25.2956 2.19157 26.3372 3.23316L27.4331 4.32909L27.2336 4.52866L27.233 4.52927L25.642 6.12026L25.6414 6.12079L22.9912 8.77104L22.9903 8.77191L21.3993 10.3629L21.3985 10.3637L10.202 21.5603L2.13442 22.7526C1.78055 22.8049 1.60361 22.831 1.48671 22.9479C1.36981 23.0648 1.34366 23.2417 1.29136 23.5956L0.0813873 31.7828C-0.00876257 32.3928 -0.0538374 32.6978 0.124007 32.8757C0.301849 33.0535 0.606838 33.0084 1.21681 32.9183H1.21684L9.40406 31.7083C9.75793 31.656 9.93486 31.6299 10.0518 31.513C10.1687 31.3961 10.1948 31.2191 10.2471 30.8653L10.2471 30.8653L11.4394 22.7977L22.6363 11.6008L22.6368 11.6003L24.2278 10.0093L24.2282 10.0089L26.8794 7.35769L28.4704 5.7667L28.6706 5.56653L29.7665 6.66246C30.8081 7.70405 31.3289 8.22485 31.8067 8.05263C32.2845 7.88042 32.3533 7.14712 32.4909 5.68053L32.8459 1.89622C32.9294 1.00564 32.9712 0.560344 32.7053 0.294398C32.4393 0.0284522 31.994 0.0702254 31.1034 0.153772ZM9.33656 23.4572L9.5425 23.6631L8.59733 30.0585L1.96026 31.0394L2.94114 24.4023L9.33656 23.4572Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_2053_1454">
      <rect
        width="33"
        height="33"
        fill="white"
        transform="translate(-0.000244141)"
      />
    </clipPath>
  </defs>
</svg>
